import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {GraphQLAnalyticsDashboardSpecFragment} from 'insights/analytics-dashboards/data/AnalyticsDashboardGQLRESTConverters';
import {AnalyticsQueryFragment} from 'insights/analytics-queries/graphql/AnalyticsQuery';

/**
 * This query is defined in its own file to avoid a circular import, since both the AnalyticsDashboardDetails
 * component and AnalyticsDashboardDetailsActions depend on it.
 *
 * The full dashboard's details has 2 parts: the part that is from the server and the part that are client
 * defined fields, which do not come from the server. The server details are extracted in a
 * SERVER_ANALYTICS_DASHBOARD_FRAGMENT so that it can be used in other places that only care about the server
 * part such as refreshDetails.
 */
export const GET_ANALYTICS_DASHBOARD_QUERY = gql`
  query GetAnalyticsDashboard($analyticsDashboardId: StrictString!) @skipAudit @engComponent(name: INSIGHTS) {
    analyticsDashboard(id: $analyticsDashboardId) {
      ... on AnalyticsDashboardNode {
        ...GraphQLAnalyticsDashboardSpec
        analyticsQueries {
          ...AnalyticsQuery
        }
        createdAt
        creator {
          id
          handle
          name
        }
        layoutRows {
          analyticsQueries {
            ...AnalyticsQuery
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${AnalyticsQueryFragment.fragment}
  ${GraphQLAnalyticsDashboardSpecFragment.fragment}
`;
